import { render, staticRenderFns } from "./test.vue?vue&type=template&id=4e8185ee&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8185ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e8185ee')) {
      api.createRecord('4e8185ee', component.options)
    } else {
      api.reload('4e8185ee', component.options)
    }
    module.hot.accept("./test.vue?vue&type=template&id=4e8185ee&scoped=true", function () {
      api.rerender('4e8185ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/platformManagement/customerServiceManagement/orderList/test.vue"
export default component.exports